module.exports = __webpack_public_path__ + "static/media/atividade-coletiva-detalhe.69569a00.webp";